import React from "react";

export const LinkPage = ({ children }) => {
    console.log(children);
    return (
        <div style={{marginTop: '20px', textAlign: 'center'}}>
            <a className='text-secondary center' href={children.p[1].value}>{children.p[2].value}</a>
        </div>
    );
};